import { PILE_PRATA } from '../assets/items';
import { ImgAparada } from './RetratoMob';
import { useIconeTingido } from './useIconeTingido';

/**
 * Ícone aparado de um item pelo id, já tingido pelo material (`plate-chest@valorite` sai azul, `bow@oak`
 * sai de carvalho). Para as grades que não usam o `ItemIcon` (saque da caçada, leilão): antes elas chamavam
 * `iconePara` direto e toda variante aparecia com a arte de ferro.
 */
export function IconeItem({ id, className, title }: { id: string; className?: string; title?: string }) {
  const src = useIconeTingido(id);
  return <ImgAparada className={className} src={id === 'silver' ? PILE_PRATA : src} title={title} />;
}
